import {
  faDownload,
  faEye,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { getArchivedJobs } from 'store/Recruitment/actions'
import moment from 'moment'
import { clientBaseUrl } from 'utils/AxiosInstance'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

function JobArchived() {
  const dispatch = useDispatch()
  const { archivedJobs } = useSelector((store) => store.recruitment)
  const [showModal, setShowModal] = useState()

  const history = useHistory()

  const columns = [
    {
      headerName: 'No',
      field: 'no',
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: 'Name',
      field: 'name',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) => (
        <button
          className='btn btn-outline-info'
          onClick={() => {
            history.push(
              `/job/application/details?application=${params.data.id}`
            )
          }}
        >
          {params.value}
        </button>
      ),
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Applied For',
      field: 'job_title',
      sortable: true,
      unSortIcon: true,
    },
    { headerName: 'Rating', field: 'rating', sortable: true, unSortIcon: true },
    {
      headerName: 'Applied At',
      field: 'created_at',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'Resume',
      field: 'resume',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) => (
        <>
          {params.data.resume ? (
            <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
              <FontAwesomeIcon
                size='lg'
                icon={faDownload}
                title='Download'
                role='button'
                className='text-success'
                onClick={() => {
                  const url = clientBaseUrl()
                  const resumeUrl = encodeURIComponent(params.data.resume)
                  const proxyUrl = `${url}/recruitment/proxy-resume?url=${resumeUrl}`

                  const link = document.createElement('a')
                  link.href = proxyUrl
                  link.setAttribute('download', '')
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }}
              />
              <FontAwesomeIcon
                size='lg'
                icon={faMagnifyingGlass}
                title='View'
                role='button'
                className='text-info'
                onClick={() => {
                  window.open(params.data.resume, '_blank')
                }}
              />
            </div>
          ) : (
            '-'
          )}
        </>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faEye}
            title='Edit'
            role='button'
            className='text-warning'
            onClick={() => {
              history.push(
                `/job/application/details?application=${params.data.id}`
              )
            }}
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  useEffect(() => {
    dispatch(getArchivedJobs())
  }, [dispatch])

  return (
    <Card>
      <CardBody>
        <div
          className='ag-theme-alpine'
          style={{ height: '600px', width: '100%' }}
        >
          <AgGridReact
            columnDefs={columns}
            rowData={archivedJobs}
            defaultColDef={defaultColDef}
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default JobArchived
